/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import './App.scss';
import './Styles/bootstrap.min.css';
import './Styles/styles.scss';
import { useDispatch, useSelector } from 'react-redux';
import Error from 'Screens/Error';
import { validateSession } from 'Screens/Login/actions/Actions';
import { selectLocation } from 'store/Router/selectors';
import { selectIsLoggedIn, selectIsValidatingSession } from 'store/Sesion/selectors';
import { setUrlReturn } from 'Screens/Contextualization/Faraday/actions/Actions';

import errorHandler from './Common/Handlers/ErrorHandler';
import FileUploadContext from './Common/Components/FileUploadContext';
import RedirectModal from './Common/Components/RedirectModal';
import { Content, Wrapper } from './styled';
import { selectShowProcessingQueue } from 'store/FileUploaderContext/selector';
import SpinnerComponent from 'Common/Components/SpinnerContainer';

import NavMenuContext from 'Screens/Contextualization/NavMenu';
import SideBarContext from 'Screens/Contextualization/Sidebar';
import TabsContext from 'Screens/Contextualization/Tabs';
import CommandValidator from 'Common/Components/CommandValidator';

const App = ({ logOut, children }) => {
  const location = useSelector(selectLocation);
  const isValidatingSession = useSelector(selectIsValidatingSession);
  const showImportModal = useSelector(selectShowProcessingQueue);
  const loggedIn = useSelector((state) => selectIsLoggedIn(state));
  const dispatch = useDispatch();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    dispatch(setUrlReturn(location.pathname));
    dispatch(validateSession());
    errorHandler(logOut);
    setMounted(true);
  }, [dispatch]);

  if ((!mounted || isValidatingSession) && location.pathname !== '/') return null;
  if (isValidatingSession) return <SpinnerComponent height="100%" />;
  return (
    <>
        <Wrapper>
          <NavMenuContext />
          <SideBarContext />
          <TabsContext />
          <Content>
            { children }
          </Content>
          <RedirectModal />
          <Error />
          { (showImportModal && loggedIn) && <FileUploadContext /> }
          <CommandValidator />
        </Wrapper>
    </>

  );
};

export default App;
